import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { NoveltyCheckReportContext } from '../novelty-check-report-context';
import type { NoveltyCheckReportState } from '../novelty-check-report-state';
import { Logger } from '@patsnap/tahiti-core';
import { NoveltyCheckTaskStep } from '@/domains/novelty-check-report/enums';
import { NoveltyCheckTaskStatusModel } from '@/domains/novelty-check-report/models/novelty-check-task-status-model';
import { ReportResultRefresh } from '../../report-result-refresh';
import { NoveltyCheckTaskStatusService } from '../../task-status-service';
import { NoveltyCheckStepInfoStatus } from '@/domains/novelty-check-report/types';

@injectable()
export class ResultState implements NoveltyCheckReportState {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(ReportResultRefresh)
        private readonly _reportResultRefresh: ReportResultRefresh,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
        @inject(NoveltyCheckTaskStatusService)
        private readonly _noveltyCheckTaskStatusService: NoveltyCheckTaskStatusService,
    ) { }

    async enter(context: NoveltyCheckReportContext): Promise<void> {
        await this._noveltyCheckTaskStatusService.pullTaskStatus();
        // 进入结果状态的逻辑
        this._logger.info('进入结果状态');
        this._switchTaskStep(NoveltyCheckTaskStep.REPORT_CREATED);
        this._logger.info('开始生成报告');
        await this._reportResultRefresh.refresh();
        setTimeout(async () => {
            context.setStepStatus(this, NoveltyCheckStepInfoStatus.LEAVING);
            context.setStepStatus(this, NoveltyCheckStepInfoStatus.LEFT);
            this._logger.info('生成报告完成');
        }, 0);
    }

    async handleNext(): Promise<void> {
        // 结果状态是最后一步，没有下一步
        this._logger.info('结果状态是最后一步，没有下一步');
    }

    async handlePrevious(context: NoveltyCheckReportContext): Promise<void> {
        // 返回生成特征对比表状态
        const generateFeatureCompareTableState = context.getState(NoveltyCheckTaskStep.GENERATE_FEATURE_COMPARE_TABLE);
        await context.transitionTo(generateFeatureCompareTableState);
    }

    private _switchTaskStep(step: NoveltyCheckTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }
}
